import React from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';

const CatalogoAdmin = () => {
  const params = useParams();
  const slug = params.slug || localStorage.getItem('slug'); // si no viene por URL, lo toma del localStorage
  const url = `${window.location.origin}/catalogo/${slug}`;

  return (
    <div className="container mt-4">
      <h2>Catálogo público</h2>
      <p>Compartí este enlace con tus clientes para que vean tu carta digital:</p>

      <div className="mb-3">
        <input
          className="form-control"
          value={url}
          readOnly
          onClick={(e) => e.target.select()}
        />
      </div>

      <QRCodeCanvas value={url} size={200} />

      <p className="mt-3">
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline-primary"
        >
          Ver catálogo público
        </a>
      </p>
    </div>
  );
};

export default CatalogoAdmin;
